
$(document).ready(function() {

    let coms = dataCcode==='ccode-CH' ? 1+0.25/100 : 1+0.5/100,
        $inConv = $('#in-conv'),
        $inGet  = $('#in-get'),
        $slConv = $('#sl-conv'),
        $slGet  = $('#sl-get'),
        $duRate = $('#duRate'),
        $reRate = $('#reRate'),
        $yuSave = $('#yuSave'),
        $exRate = $('.conv-form').attr('data-exrate')*1;

    if(!!$exRate) coms = 1+$exRate/100
    else coms = 1+0.1/100;

    // console.log($exRate);
    // console.log(coms);
    // lPar = $slConv.val();
    // rPar = $slGet.val();

    if ($inConv[0]) {
        obmen();

        $('.conv-form .sep').click(function (){// обработка валюты

            $slGet.val(lPar).parent().find('.valdrop').html(lPar);
            $slConv.val(rPar).parent().find('.valdrop').html(rPar);

            lPar = $slConv.val();
            rPar = $slGet.val();
            cPar = lPar+'/'+rPar;
            obmen();
        });

        $('.drop .val').click(function (){// обработка валюты

            if($slConv.val()===$slGet.val()){
                // console.log($(this).parents('.form'));
                if ($(this).parents('.f-conv')[0]) {
                    $slGet.val(lPar).parent().find('.valdrop').html(lPar);
                } else $slConv.val(rPar).parent().find('.valdrop').html(rPar);
            }

            lPar = $slConv.val();
            rPar = $slGet.val();
            cPar = lPar+'/'+rPar;
            obmen();
        });
    }

    $inConv.on('change keyup input',function () {

        if($(this).attr('name')==='in-conv') {// обработка суммы
            rPar = $slGet.val();
            cPar = $slConv.val()+'/'+rPar;
            obmen()
        }
    });

    $inGet.on('change keyup input',function () {

        if($(this).attr('name')==='in-get') {// обработка суммы
            rPar = $slGet.val();
            cPar = $slConv.val()+'/'+rPar;

            $.ajax({
                type: "GET",
                url: 'https://www.dukascopy.com/api/forex-convert/'+cPar,
                cache: false,
                success: function (data) {
                    // console.log('course',data);
                    curPar = data/coms;
                    // console.log('result',curPar);

                    let rez = $inGet.val() / curPar;

                    $inConv.val(rez.toFixed(2));
                    $duRate.html(curPar.toFixed(5))
                    $reRate.html((data/1.03).toFixed(5))
                    $yuSave.html(($('#in-get').val() - ($inConv.val()*data/1.03)).toFixed(2)+' '+rPar)
                },
                error : function(jqXhr, textStatus, errorMessage){
                    console.log('error',textStatus, errorMessage);
                }
            });
        }
    });

    function obmen(){
        $.ajax({
            type: "GET",
            url: 'https://www.dukascopy.com/api/forex-convert/'+cPar,
            cache: false,
            success: function (data) {
                // console.log('course',data);
                curPar = data/coms;
                // console.log('result',curPar);

                let rez = $inConv.val() * curPar,
                    rezRet = $inConv.val() * data/1.03;
                // console.log(rez);
                $inGet.val((rez).toFixed(2));
                $duRate.html(curPar.toFixed(5))
                $reRate.html((data/1.03).toFixed(5))
                $yuSave.html((rez - rezRet).toFixed(2)+' '+rPar)
            },
            error : function(jqXhr, textStatus, errorMessage){
                console.log('error',textStatus, errorMessage);
            }
        });
    }
});